module.exports = __webpack_public_path__ + "6d4fabff223fc2a32f7889281f8512b1.fbx";